import { combineReducers } from 'redux'
import visit from './visit'
import modal from './modal'
import payment from './payment'
import userTracks from './userTracks'
import lang from './lang'
import webRtcStats from './webRtcStats'
import textMessage from './textMessage'
import dialog from './dialog'

export default combineReducers({
  visit,
  modal,
  payment,
  userTracks,
  lang,
  webRtcStats,
  textMessage,
  dialog
})
